import * as React from 'react';
import { Header4, Paragraph2 } from '@cian/ui-kit';
import { ArrowR12 } from '@cian/ui-kit/icons';

import { ISalesLink } from '../../../../types/salesLink';
import { SALES_TYPE_ICONS } from '../../constants';

import * as styles from './SalesLink.css';

interface ISalesLinkProps {
  link: ISalesLink;
  onClick?(link: ISalesLink, event: React.MouseEvent<HTMLAnchorElement>): void;
}

export function SalesLink({ link, onClick }: ISalesLinkProps) {
  const iconSource = SALES_TYPE_ICONS.get(link.salesType);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (onClick) {
        onClick(link, event);
      }
    },
    [onClick, link],
  );

  return (
    <a className={styles['link']} href={link.url} onClick={handleClick}>
      <div className={styles['container']}>
        {iconSource && <img className={styles['icon']} src={iconSource} alt="" />}
        <div className={styles['content']}>
          <div className={styles['title']}>
            <Header4 as="h4">{link.title}</Header4>
          </div>
          <Paragraph2 color="gray60_100">{link.text}</Paragraph2>
        </div>
        <div className={styles['arrow']}>
          <ArrowR12 color="primary_100" />
        </div>
      </div>
    </a>
  );
}
